export default "__VITE_ASSET__DzHD0aBY__"